import React, {useState} from "react";
import Post from "../Post/Post";
const text = `🔥 Asset: Bitcoin (BTC) 
⌛️ Timeframe: Short-Term (1-2 days) 
💼 Position: Buy 
🎯 Target: $45,000 
🛡️ Stop-Loss: $42,000
💡 Analysis: 

Bitcoin (BTC) has shown strong bullish momentum, breaking through key resistance levels and forming higher highs. The overal l market sentiment is positive, with increasing buying pressure. Technical indicators suggest a potential upward continuation in the short-term.
📊 Trade Rationale: 
Based on our analysis, we anticipate Bitcoin to sustain its upward trajectory and reach the target price of $45,000. However, always remember to manage risk by setting a stop-loss order at $42,000 to protect against unexpected market fluctuations.

Forex`;

const reportText = `🔥 Asset: Bitcoin (BTC) 
⌛️ Timeframe: Short-Term (1-2 days) 
💼 Position: Buy 
🎯 Target: $45,000 
🛡️ Stop-Loss: $42,000 

💡 Analysis: 
Ethereum (ETH) has demonstrated significant strength in recent weeks, forming higher highs and establishing a solid uptrend. The overall market sentiment remains bullish, with Ethereum leading the way in the cryptocurrency space. Fundamental factors, such as the growing adoption of decentralized finance (DeFi) applications and the anticipated Ethereum 2.0 upgrade, contribute to the positive outlook.

📊 Technical Analysis: 

1. The price is above key moving averages, including the 50-day and 200-day moving averages, indicating a healthy uptrend. This suggests that Ethereum's bullish momentum is strong and likely to continue in the medium-term.

2. The Relative Strength Index (RSI) remains in bullish territory, showing room for further upside potential. This indicates that there is buying pressure and that Ethereum's price has room to increase before reaching overbought levels.

3. Volume has been increasing during upward price movements, reflecting strong buying pressure. This indicates that there is significant interest from market participants in accumulating Ethereum.

💰 Trade Rationale:
Based on our comprehensive analysis, we anticipate Ethereum to continue its upward trajectory in the medium-term. Our initial target is set at $4,000, which represents a significant resistance level. This level has historical significance and may act as a psychological barrier for the price. If Ethereum manages to surpass this level, it has the potential to reach our second target of $4,500. This target represents a key resistance level and may provide a strong upside opportunity for traders and investors. 
It is important to note that cryptocurrency markets are highly volatile, and price movements can be swift and unpredictable. Risk management is crucial in trading, so we recommend setting a stop-loss order at $3,200 to protect against unexpected market fluctuations. This level is below key support levels and allows for a reasonable risk-reward ratio. 
`;
const PostContent = ({ className }) => {
  const Small = () => (
    <div className=" bg-[#2A2D37] rounded-[10px] relative ">
      <div className="flex justify-between">
        <button className="text-[#2A2D37] font-bold text-res-xs w-[237px] bg-main-green h-[26px] rounded-tl-[10px] rounded-br-[10px]">
          Bitcoin Rally this week
        </button>
        <h4 className="mt-[14px] text-[12px] mr-[30px]">17th May, 2023</h4>
      </div>
      <div className="mt-[10px] tracking-[0.06em] font-medium whitespace-pre-wrap px-[35px] pb-[12px]  text-[14px] break-words">
        Bitcoin (BTC) has shown strong bullish momentum, breaking through key
        resistance levels and forming higher highs. The overal l market
        sentiment is positive, with increasing buying pressure. Technical
        indicators suggest a potential upward continuation in the short-term.
      </div>
      <button className="text-[#2A2D37] font-bold text-[12px] w-[114px] bg-main-green h-[26px] rounded-tl-[10px] rounded-br-[10px] absolute right-0 bottom-0">
        Read More
      </button>
    </div>
  );
  return (
    <div className={`flex lg:flex-row flex-col  gap-[44px] ${className}`}>
      <div className=" bg-main-black  xl:min-w-[622px] xl:max-w-[622px]  min-h-[500px] rounded-[10px] relative">
        <div className=" mb-[30px]">
          <button className="text-[#2A2D37] font-bold text-res-sm w-[122px] bg-main-green h-[50px] rounded-tl-[10px] rounded-br-[10px]">
            Report
          </button>
        </div>
        <div className="tracking-[0.06em] font-medium whitespace-pre-wrap px-[27px] pb-[50px] leading-[20.5px]  text-[16px] break-words">
          {reportText}
        </div>
      </div>
      <div className="grow pt-[36px] pl-[22px] pr-[11px] h-[1064px] rounded-[10px]  bg-main-black">
        <div className="overflow-y-scroll pb-[289px] h-[1029px] btcWrap pr-[8px] flex flex-col gap-[10px]">
          <Post text={text} defaultOpen={true}></Post>
          <Post
            text={
              "Bitcoin (BTC) has shown strong bullish momentum, breaking through key resistance levels and forming higher highs. The overal l market sentiment is positive, with increasing buying pressure. Technical indicators suggest a potential upward continuation in the short-term. "
            }
            defaultOpen={false}
          ></Post>
        </div>
      </div>
    </div>
  );
};

export default PostContent;
